import Vue from 'vue'
import i18n from '@/i18n'
import { handle as validateCellphone, countries } from '@/plugins/CellphoneValidator'

class FormErrorValidator {
    private forbiddenWords = ['select', 'from', 'console', 'log', 'alert', 'delete', 'distinct', 'import']

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public validateFields (value: any, typeId: number) {
      let message = null
      let error = null

      if (value) {
        if (typeId === 9) {
          error = !this.formatValidator(value)
          if (error) message = 'Rut invalido'
          // eslint-disable-next-line brace-style
        }

        else if (typeId === 3) {
          error = !/^[a-zA-ZáéíóúüñÁÉÍÓÚÜÑ\s]+$/.test(value)

          if (!error) {
            const match = this.validateForbiddenWords(value)
            if (match > -1) {
              error = true
              message = `${i18n.t('initialForm.formErrors.forbiddenWord')} '${this.forbiddenWords[match]}'`
            }
          } else {
            message = i18n.t('initialForm.formErrors.onlyText')
          }
          // eslint-disable-next-line brace-style
        }

        else if (typeId === 5) {
          error = !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(value)
          if (error) message = i18n.t('initialForm.formErrors.invalidEmail')
          // eslint-disable-next-line brace-style
        }

        else if (typeId === 6) {
          const match = this.validateForbiddenWords(value)
          if (match > -1) {
            error = true
            message = `${i18n.t('initialForm.formErrors.forbiddenWord')} '${this.forbiddenWords[match]}'`
          }
          // eslint-disable-next-line brace-style
        }

        else if (typeId === 4) {
          error = !/^[0-9]+$/.test(value)
          if (error) message = i18n.t('initialForm.formErrors.onlyNumber')
          // eslint-disable-next-line brace-style
        }

        else if (typeId === 7) {
          error = !/^[0-9]+$/.test(value)
          if (value) message = i18n.t('initialForm.formErrors.invalidPhone')
          // eslint-disable-next-line brace-style
        }

        else if (typeId === 10) {
          error = !/^\+?[0-9]+$/.test(value)

          if (error) {
            message = i18n.t('initialForm.formErrors.invalidPhone')
          } else {
            const isValid = validateCellphone(value)

            if (!isValid) {
              const country = countries.find(country => value.startsWith(country.dial_code))
              const min = country?.validation_rules.phone.min_length || 0
              const max = country?.validation_rules.phone.max_length || 0
              const countryName = country?.name || 'el país'

              if (min === max) {
                message = i18n.t('initialForm.formErrors.invalidPhoneLengthExact', { min, countryName })
              } else {
                message = i18n.t('initialForm.formErrors.invalidPhoneLength', { min, max, countryName })
              }

              error = true
            }
          }
        }
      } else {
        error = true
        message = i18n.t('initialForm.formErrors.requiredField')
      }

      return { error, message }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private validateForbiddenWords (value: any) {
      value = value.toLowerCase()
      for (let i = 0; i < this.forbiddenWords.length; i++) {
        const regex = new RegExp('\\b' + this.forbiddenWords[i] + '\\b')
        if (regex.test(value)) {
          return i
        }
      }
      return -1
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private formatValidator (value: any) {
      if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(value)) {
        return false
      }

      const tmp = value.split('-')
      const rut = tmp[0]
      let digv = tmp[1]

      if (digv === 'K') {
        digv = 'k'
      }

      // eslint-disable-next-line eqeqeq
      return (this.validator(rut) == digv)
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private validator (T: any) {
      let M = 0; let S = 1

      for (; T; T = Math.floor(T / 10)) {
        S = (S + T % 10 * (9 - M++ % 6)) % 11
      }

      return S ? S - 1 : 'k'
    }
}

Vue.prototype.$FormErrorValidator = new FormErrorValidator()
